import { WrappedRecurlyProvider } from "./WrappedRecurlyProvider";

export default WrappedRecurlyProvider;
